import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import DomainService from '../services/domainService';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, hasCompletedSetup, user, isNewUser } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-purple-700 animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Only check Azure setup for NEW users who just signed up
  // Skip this check if we're already on the Azure setup page
  if (isNewUser && !hasCompletedSetup && location.pathname !== '/azure-setup') {
    // Only redirect to Azure setup if user has a business email
    if (user?.email && !DomainService.isPublicEmailDomain(user.email)) {
      return <Navigate to="/azure-setup" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;